/**
 * Error Boundary
 *
 * Catches React rendering errors and displays a friendly error page.
 * Prevents white-screen-of-death on unexpected errors.
 */

import { Component, ReactNode } from "react";
import { ErrorPage } from "@/pages/ErrorPage";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: { status?: number; message?: string } | null;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error: { message: error.message } };
  }

  render() {
    if (this.state.hasError) {
      return <ErrorPage error={this.state.error ?? undefined} />;
    }

    return this.props.children;
  }
}
